import { BOToothReparationDetail } from "./BOToothReparationDetail.model";
import { BOToothStateDetailToothFace } from "./BOToothStateDetailToothFace.model";

export class BOToothStateDetail{
  id:number;
  toothStateDetailIdTemp?:number;
  toothTypeId:number;
  toothStateId:number;
  toothStateCategoryId?:number;
  personId:number;
  date?:Date;
  odontogramaId?:number;

  clinicHistoryOdontologyId?:number;
  selected?:boolean=false;
  observations?:string;
  toothFaces:BOToothStateDetailToothFace[]=[];
  price?:number;
  fixed?:boolean | null;

  //new
  margin:string;
  verticalPosition:string;
  icd10Code:string;  //corresponde a code de BOToothStateType
  icd10Name:string;
  icd11Code:string;
  icd11Name:string;
}

